import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/home/Home.vue')
  },
  {
    path: '/bewertung',
    name: 'Evaluation',
    component: () => import(/* webpackChunkName: "Evaluation" */ '../views/evaluation/Evaluation.vue')
  }, 
  {
    path: '/marktplatz',
    name: 'Marketplace',
    component: () => import(/* webpackChunkName: "Marketplace" */ '../views/sellingSoon/sellingSoon.vue')
  }, 
  {
    path: '/termin-:id',
    name: 'Termin',
    props: true,
    component: () => import(/* webpackChunkName: "Termin" */ '../views/termin/termin.vue')
  }, 
  {
    path: '/g53y-:id',
    name: 'NotSelling',
    props: true,
    component: () => import(/* webpackChunkName: "NotSelling" */ '../views/notSelling/notSelling.vue')
  }, 
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: () => import(/* webpackChunkName: "Privacy" */ '../views/special/privacyDE.vue')
  }, 
  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import(/* webpackChunkName: "Impressum" */ '../views/special/impressum.vue')
  }, 
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/special/404.vue')
  }, 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) { //eslint-disable-line
    return { x: 0, y: 0 }
  }, 
})

export default router
